import { useMemo } from 'react';
import { cn } from '@shared/utils';
import type { AttachmentsResponse } from '@shared/api';
import { Button, Icon, Text } from '@shared/widgets';
import FileIcon from '@assets/icons/file.svg';
import CloseIcon from '@assets/icons/close.svg';
import DownloadIcon from '@assets/icons/download.svg';

export interface MessageFileProps {
  attachment: Partial<AttachmentsResponse>;
  onRemove?: () => void;
  onDownload?: () => void;
}

export const File = (props: MessageFileProps) => {
  const fileSizeKb = useMemo(() => {
    if (props.attachment.fileSizeBytes) return Math.round(props.attachment.fileSizeBytes / 1024);
    return;
  }, [props.attachment]);

  if (!props.attachment) return null;
  return (
    <div className='max-w-[293px]'>
      <div className='relative m-0 inline-flex h-10 w-full max-w-full items-center justify-between gap-2 rounded-sm border-b border-b-light bg-ice pl-3 text-eerie-black hover:bg-white dark:border-b-primary dark:bg-soft-black dark:text-ice'>
        <div className='h-5 w-5 flex-none'>
          <FileIcon />
        </div>
        <Text className='max-w-[160px] flex-[inherit] overflow-hidden text-ellipsis whitespace-nowrap' weight='light' size='sm'>
          {props.attachment.filename}
        </Text>
        <Text className={cn('relative top-[1px] flex-none whitespace-nowrap opacity-60', !(props.onRemove || props.onDownload) && 'pr-3')} size='xs'>
          {fileSizeKb ? `${fileSizeKb}kb` : ''}
        </Text>
        {(props.onRemove || props.onDownload) && (
          <div className='flex'>
            {props.onRemove && (
              <Button className='p-0 pr-3' onClick={props.onRemove}>
                <Icon icon={<CloseIcon width='10' height='10' />} />
              </Button>
            )}
            {props.onDownload && (
              <Button className='h-10 w-11 rounded-none p-0' color='primary' onClick={props.onDownload}>
                <Icon icon={<DownloadIcon />} color='inherit' />
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
